import React from 'react';
import { BookingDetails } from '@/hooks/bookings/types';
import { Badge } from '@/components/ui/badge';
import BookingHeaderSection from './BookingHeaderSection';
interface BookingHeaderInfoProps {
  booking: BookingDetails;
  isAdmin: boolean;
}
const BookingHeaderInfo: React.FC<BookingHeaderInfoProps> = ({
  booking,
  isAdmin
}) => {
  return (
    <BookingHeaderSection booking={booking} isAdmin={isAdmin} showContactButtons={true} />
  );
};
export default BookingHeaderInfo;